import { useGetUsersTasksDefaultsSpectators } from '../../../hooks/queries/users-tasks/defaults/users-tasks-spectators-defaults/use-get-users-tasks-spectators-defaults'
import { TaskItem } from './daily-components/task-item'

export function TasksSpectators() {
  const { usersTasksSpectatorsDefaults } = useGetUsersTasksDefaultsSpectators()

  return usersTasksSpectatorsDefaults?.map((task) => (
    <TaskItem key={task.id} task={task} type="spectator" />
  ))
}
